export function tryGetObjectByProperty(array: object[], property: string, value: string) {
    return array.find(s => s[property].toLowerCase() === value.toLowerCase()) ?? null;
}